import { http } from '@pendo/http';

export function loadSubscribedItems () {
    return http.get('/api/s/_SID_/notification').then((res) => res.data);
}

export function subscribeToItem (targetId, itemType, flag = '') {
    return http.post(`/api/s/_SID_/notification/item/${itemType}/${targetId}/subscribe${flag}`, {
        headers: { 'Content-Type': 'application/json' },
    });
}

export function subscribeOthersToItem (itemId, itemType, flag = '', payload = {}) {
    return http.post(`/api/s/_SID_/notification/item/${itemType}/${itemId}/subscribeothers${flag}`, payload);
}

export function subscribeToAllItems (itemType, targetType) {
    return http.post(`/api/s/_SID_/notification/${itemType}/subscribe`, {
        targetType,
        targetIds: ['*'],
    });
}

export function unsubscribeFromItem (targetId, itemType) {
    return http.post(`/api/s/_SID_/notification/item/${itemType}/${targetId}/unsubscribe`, {
        headers: { 'Content-Type': 'application/json' },
    });
}

export function unsubscribeOthersFromItem (itemId, itemType, payload = {}) {
    return http.post(`/api/s/_SID_/notification/item/${itemType}/${itemId}/unsubscribeothers`, payload);
}

export function unsubscribeFromAllItems (itemType, targetType) {
    return http.put(`/api/s/_SID_/notification/${itemType}/unsubscribe`, {
        targetType,
        targetIds: ['*'],
    });
}

export async function fetchNotificationsByType (notificationType) {
    return http
        .get(`/api/s/_SID_/notification/${notificationType}`)
        .then((response) => response.data.reduce((current, item) => current.concat(item.targetId), []))
        .catch((error) => {
            throw new Error(`Fetch ${notificationType} notifications error`, error);
        });
}

export async function fetchNotificationsByTypeAndTargetTypeAndId (notificationType, targetType, targetId) {
    return http
        .get(`/api/s/_SID_/notification/${notificationType}/${targetType}/${targetId}`)
        .then((response) => {
            if (response.data?.users === null) return [];

            return (
                response.data?.users || response.data.reduce((current, item) => current.concat(item.ownedByUser), [])
            );
        })
        .catch((error) => {
            throw new Error(`Fetch ${notificationType} notifications for ${targetId} error`, error);
        });
}

export async function sendNotificationEmail (notificationType, targetType, targetId, payload = {}) {
    const postPayload = {
        headers: { 'Content-Type': 'application/json' },
        ...payload,
    };

    return http.post(`/api/s/_SID_/${notificationType}/${targetId}/${targetType}/email`, postPayload).catch((error) => {
        throw new Error(`Send ${notificationType} notification email for ${targetId} error`, error);
    });
}

export function loadPreviewEmail (targetId, notificationType, title, description) {
    return http
        .post(`/api/s/_SID_/notification/${notificationType}/emailpreview/${targetId}`, { title, description })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getSubscribedVisitorsAgg (notificationType, targetType, targetId, metadataField) {
    return http
        .get(`/api/s/_SID_/notification/${notificationType}/${targetType}/agg/${targetId}/${metadataField}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
